export default __webpack_public_path__ + "static/media/wallet-connect-text.0fa02f19.svg";